import { AnimeCard } from './AnimeCard'
import { Anime } from '@/types/anime'

interface AnimeGridProps {
  animeList: Anime[]
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

export function AnimeGrid({ animeList, size = 'md', className = '' }: AnimeGridProps) {
  if (animeList.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-400 text-lg">No anime found</p>
      </div>
    )
  }

  const gridClasses = {
    sm: 'grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-8',
    md: 'grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6',
    lg: 'grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5'
  }

  return (
    <div className={`grid ${gridClasses[size]} gap-6 ${className}`}>
      {animeList.map((anime) => (
        <AnimeCard key={anime.id} anime={anime} size={size} />
      ))}
    </div>
  )
}
